






























import {
  Component,
  Watch,
} from 'vue-property-decorator';

import {
  Image,
  ImageTag,
  ProductVariant,
} from '@/models';

import ProductFeature from './ProductFeature';
import ImageCarouselView from './imageBlock/ImageCarouselView.vue';
import ImageListView from './imageBlock/ImageListView.vue';

@Component({
  components: {
    ImageCarouselView,
    ImageListView,
  },
})
export default class ImageBlockFeature extends ProductFeature {
  // Image tags that recognized by this storefront. The images are also displayed in the order based
  // their tags listed in this array.
  private static readonly IMAGE_TAGS = [
    ImageTag.MainImage,
    ImageTag.ProductAlt1Image,
    ImageTag.ProductAlt2Image,
    ImageTag.ProductAlt3Image,
    ImageTag.ProductAlt4Image,
    ImageTag.ProductAlt5Image,
    ImageTag.ProductAlt6Image,
    ImageTag.ProductAlt7Image,
    ImageTag.ProductAlt8Image,
    ImageTag.ProductAlt9Image,
  ];

  public images: Image[] | null = null;
  public previewImage: Image | null = null;

  private variantImages = new Map</* ProductVariant.id */string, Image[]>();

  public created() {
    this.onVariantChanged();
  }

  @Watch('variant')
  public onVariantChanged() {
    // Load images.
    this.images = this.getImagesFor(this.variant);
  }

  @Watch('previewVariant')
  public onPreviewVariantChanged() {
    if (!this.previewVariant) {
      this.previewImage = null;
    } else {
      const images = this.getImagesFor(this.previewVariant);
      if (images) {
        this.previewImage = images[0];
      }
    }
  }

  private getImagesFor(variant: ProductVariant) {
    let images = this.variantImages.get(variant.id) || null;
    if (images) {
      // Cache hit.
      return images;
    }

    if (variant.images) {
      // Filter and order the images corresponding to IMAGE_TAGS.
      images = variant.images
        .filter((image) => (ImageBlockFeature.IMAGE_TAGS.find((tag) => tag === image.tag)))
        .sort((a, b) => {
          const aIdx = ImageBlockFeature.IMAGE_TAGS.findIndex((tag) => a.tag === tag);
          const bIdx = ImageBlockFeature.IMAGE_TAGS.findIndex((tag) => b.tag === tag);
          return aIdx - bIdx;
        });
    }

    // Cache the result.
    this.variantImages.set(variant.id, (images) ? images : []);

    return images;
  }
}

